import { Col, Image, Row, Typography } from 'antd';
import logo from '../../assets/images/Sportsfeed24-Logo-Official.webp';
import dmcaImage from '../../assets/dmcaproteted.png';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { styles } from '../../styles';

export default function FooterComponent() {
  return (
    <>
      {/* DMCA / Disclaimer Section */}
      <Row gutter={24} style={{ ...styles.flexDisplay, marginBottom: '10px' }}>
        <Col span={16}>
          <Row gutter={24} style={styles.flexDisplay}>
            <Image width={80} src={dmcaImage} alt='dmca-logo' />
          </Row>
          <Row gutter={24}>
            <Typography.Text style={{ color: '#fff' }}>
              Disclaimer: Sportsfeed24 (also known as 24sportsfeed or sportfeed24) operates as an independent sports media platform and does not host or stream any live video content on its servers. All external links — including soccer streams, NFL streams Reddit links, and other live sports references — are sourced from publicly available third-party platforms such as YouTube and similar providers. Users are advised to ensure compliance with their local regulations. Sportsfeed24 bears no responsibility for content hosted by external sites.
            </Typography.Text>
          </Row>
        </Col>
      </Row>

      {/* Footer Navigation and Copyright */}
      <Row gutter={24} style={styles.flexDisplay}>
        <Col span={4}>
          <Image
            width={40}
            src={logo}
            preview={false}
            alt='soccer streams sportsfeed24-logo'
          />
        </Col>
        <Col span={4}>
          <Link to={'/about'}>
            <Typography.Text style={{ color: '#fff' }}>About Us</Typography.Text>
          </Link>
        </Col>
        <Col span={4}>
          <Link to={'/privacy-policy'}>
            <Typography.Text style={{ color: '#fff' }}>Privacy Policy</Typography.Text>
          </Link>
        </Col>
        <Col span={4}>
          <Link to={'/contact-us'}>
            <Typography.Text style={{ color: '#fff' }}>Contact Us</Typography.Text>
          </Link>
        </Col>
        <Col span={8}>
          <Typography.Text style={{ color: '#fff' }}>
            © {dayjs(new Date()).format('YYYY')} Sportsfeed24 — Your trusted source for live soccer streams, football updates, and real-time sports coverage. All rights reserved.
          </Typography.Text>
        </Col>
      </Row>
    </>
  );
}
